import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = {
  key: 0,
  class: "drv-py-2"
}

import CheckConnection from "../CheckConnection.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  EAuthTypes,
  ECommonMessages,
  IBaseBasic,
  EPlatformName,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import HelpLink from "@/modules/onboarding/components/blocks/telematics/HelpLink.vue";
import { HELP_URL_BY_PLATFORM } from "../../../../constants/instruction-url-by-platform";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseUserPassword',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isDiasbled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref<boolean>(false);

const EMPTY_MODEL = { type: EAuthTypes.BASIC, username: "", password: "" };

const model = computed<IBaseBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseBasic) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.BASIC
  );
});
const url = computed<string | null>(() => {
  return currentMethod.value?.url ?? null;
});
const isConnectionValid = ref<boolean | null>(
  props.modelValue || !currentMethod.value?.check_connection ? true : null
);

const clearConnection = () => {
  emit("update:modelValue", {
    type: EAuthTypes.BASIC,
    username: "",
    password: "",
  } as IBaseBasic);
};

const nameControl = ref<typeof Input | null>(null);
const passwordControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !usernameModel.value ||
    nameControl.value?.hasError ||
    !passwordModel.value ||
    passwordControl.value?.hasError
  );
});
const hasError = computed<boolean>(() => {
  return !isConnectionValid.value || hasFormError.value;
});

__expose({
  hasError,
});

const RELIABLE_ELD_FAMILY = new Set<EPlatformName>([
  EPlatformName.RELIABLE_ELD,
  EPlatformName.AT_ELD,
  EPlatformName.MGK_ELD,
  EPlatformName.NOOR_ELD_SOLUTION,
  EPlatformName.ORIENT_ELD,
]);

const currentText = computed(() => {
  if (RELIABLE_ELD_FAMILY.has(props.platform.const)) {
    return {
      url: "",
      basicTitle: ETelematicsMessagesKeys.RELIABLEELD_BASIC_TITLE,
      basicTitleParams: { provider: props.platform.label },
      showApprovalSnackbar: true,
      snackbarText: ETelematicsMessagesKeys.RELIABLEELD_APPROVAL_NOTE,
    };
  }

  const fallback = {
    url:
      (HELP_URL_BY_PLATFORM as Partial<Record<EPlatformName, string>>)[
        props.platform.const
      ] ?? "",
    basicTitle: ETelematicsMessagesKeys.BASE_BASIC_TITLE,
  };

  const mapped = textByPlatformName[props.platform.const];

  return {
    url: mapped?.url ?? fallback.url,
    basicTitle: mapped?.basicTitle ?? fallback.basicTitle,
    basicTitleParams: undefined,
    showApprovalSnackbar: false,
    snackbarText: undefined,
  };
});

const textByPlatformName: Partial<
  Record<EPlatformName, { url: string; basicTitle?: string }>
> = {
  [EPlatformName.MIX_TELEMATICS]: {
    url: ETelematicsMessagesKeys.MIXTELEMATICS_INSTRUCTIONS_URL,
    basicTitle: ETelematicsMessagesKeys.BASE_BASIC_TITLE,
  },
  [EPlatformName.AZUGA]: {
    url: ETelematicsMessagesKeys.AZUGA_INSTRUCTIONS_URL,
    basicTitle: ETelematicsMessagesKeys.AZUGA_BASIC_TITLE,
  },
  [EPlatformName.AZUGA_ELD]: {
    url: "",
    basicTitle: ETelematicsMessagesKeys.AZUGA_ELD_INSTRUCTIONS_TITLE,
  },
  [EPlatformName.INTELLISHIFT]: {
    url: "",
    basicTitle: ETelematicsMessagesKeys.INTELLISHIFT_INSTRUCTIONS_TITLE,
  },
};

return (_ctx: any,_cache: any) => {
  const _component_d_snackbar = _resolveComponent("d-snackbar")!
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(currentText.value.basicTitleParams
            ? _ctx.$t(currentText.value.basicTitle, currentText.value.basicTitleParams)
            : _ctx.$t(currentText.value.basicTitle)), 1),
      (currentText.value.url)
        ? (_openBlock(), _createBlock(HelpLink, {
            key: 0,
            link: _ctx.$t(currentText.value.url)
          }, null, 8, ["link"]))
        : _createCommentVNode("", true)
    ]),
    (currentText.value.showApprovalSnackbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_d_snackbar, {
            icon: "triangle-exclamation",
            class: "drv-bg-color-b100 drv-color-b600",
            message: _ctx.$t(currentText.value.snackbarText || '')
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_d_input, {
      ref_key: "nameControl",
      ref: nameControl,
      class: "drv-form-control-adaptive",
      modelValue: usernameModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_USERNAME_TITLE),
      disable: isDiasbled.value,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "label", "disable", "rules"]),
    _createVNode(_component_d_password_input, {
      ref_key: "passwordControl",
      ref: passwordControl,
      class: "drv-form-control-adaptive",
      modelValue: passwordModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordModel).value = $event)),
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_PASSWORD_TITLE),
      disable: isDiasbled.value,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "label", "disable", "rules"]),
    (url.value && currentMethod.value?.check_connection)
      ? (_openBlock(), _createBlock(CheckConnection, {
          key: 1,
          class: "drv-py-2",
          modelValue: isConnectionValid.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isConnectionValid).value = $event)),
          loading: isLoading.value,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((isLoading).value = $event)),
          "is-model-fullfiled": !hasFormError.value,
          "platform-type": _ctx.platform.const,
          url: url.value,
          creds: model.value,
          onClear: clearConnection
        }, null, 8, ["modelValue", "loading", "is-model-fullfiled", "platform-type", "url", "creds"]))
      : _createCommentVNode("", true)
  ]))
}
}

})